import React, { PureComponent } from 'react';
import NumberFormat from 'react-number-format';
import classNames from 'classnames';

class DobField extends PureComponent {
  state = {
    value: null
  }

  handleBlur = (e) => {
    const { onBlur } = this.props;
    if (typeof onBlur === 'function') {
      const { value } = this.state;
      const valid = isValidDate(value);
      onBlur(e, value, valid);
    }
  }

  handleChange = (e) => {
    const { value } = e.target;
    const { onChange } = this.props;
    if (typeof onChange === 'function') {
      onChange(e);
    }
    this.setState({ value });
  }

  render() {
    const {
      className,
      inputClassName,
      errorMsg,
      htmlFor,
      labelText,
      labelClassName,
      ...rest
    } = this.props;

    return <div className={classNames('dob-field', className)}>
      <label htmlFor={htmlFor} className={classNames(labelClassName, { 'section-label--error': errorMsg })}>
        {labelText}
      </label>
      <NumberFormat
        data-test-id="dob-field"
        id={htmlFor}
        {...rest}
        type='tel'
        className={classNames('txt-field-input', inputClassName, {'txt-field-input--error': errorMsg })}
        display='text'
        format='##/##/####'
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        mask={['M', 'M', 'D', 'D', 'Y', 'Y', 'Y', 'Y']}
        />
      { errorMsg && <div className={'field-error-msg'}>{errorMsg}</div>}
    </div>;
  }
}

DobField.defaultProps = {
  currentDate: new Date()
};

const MONTHS_AND_DAYS = {
  1: 31,
  2: (year) => {
    return (year % 4 === 0) &&
      ((year % 400 === 0) && (year % 100 === 0) ||
      (year % 100 > 0))
      ? 29
      : 28;
  },
  3: 31,
  4: 30,
  5: 31,
  6: 30,
  7: 31,
  8: 31,
  9: 30,
  10: 31,
  11: 30,
  12: 31
};

const isValidDate = (date) => {
  const dateRegex = /(\d{2})\/(\d{2})\/(\d{4})/;

  if (date && typeof date === 'string' && dateRegex.test(date)) {
    const dateParts = /(\d{2})\/(\d{2})\/(\d{4})/.exec(date);
    const [, m, d, yy ] = dateParts;
    const month = parseInt(m, 10);
    const day = parseInt(d, 10);
    const year = parseInt(yy, 10);

    const monthDays = MONTHS_AND_DAYS[month];

    return (monthDays && typeof monthDays === 'function' &&
      (day && day <= monthDays(year))) || (monthDays && (day && day <= monthDays) || false);
  }

  return false;
};

export { isValidDate };

export default DobField;

